// src/components/RotatingSun.jsx
import React, { useRef, useEffect } from "react";
import { useFrame, useThree } from "@react-three/fiber";
import * as THREE from "three";

export default function Sun({
  // Nouveaux props
  rotate = true,
  basePosition = [50, 30, 0],

  // Props existants
  radius = 50,
  speed = 0.02,
  inclination = 0.3,
  intensity = 1.2,
  shadowCameraSize = 100,
  shadowMapSize = 2048,
}) {
  const light = useRef();
  const { scene } = useThree();

  // On positionne le target et on fixe la position de base si pas de rotation
  useEffect(() => {
    if (!light.current) return;

    const l = light.current;
    // On place la cible au centre
    l.target.position.set(0, 0, 0);
    l.parent.add(l.target);

    if (!rotate) {
      // Position fixe
      l.position.set(...basePosition);
      l.target.updateMatrixWorld();
    }
  }, [rotate, basePosition]);

  // Animation : on tourne seulement si rotate === true
  useFrame(({ clock }) => {
    if (!rotate || !light.current) return;

    // sens inversé pour que le soleil monte à l'est et descende à l'ouest
    const t = -clock.getElapsedTime() * speed;
    const x = Math.cos(t) * radius;
    const z = Math.sin(t) * radius;
    // on transforme l'inclination (0–1) en angle (0–π/2)
    const y = Math.sin(inclination * Math.PI * 0.5) * radius;

    light.current.position.set(x, y, z);
    light.current.target.updateMatrixWorld();
  });

  return (
    <directionalLight
      ref={light}
      // castShadow
      intensity={intensity}
      color="white"
      // qualité de l’ombre
      // shadow-mapSize-width={shadowMapSize}
      // shadow-mapSize-height={shadowMapSize}
      // // éviter artefacts
      // shadow-bias={-0.0001}
      // // frustum d’ombre
      // shadow-camera-near={1}
      // shadow-camera-far={200}
      // shadow-camera-left={-shadowCameraSize}
      // shadow-camera-right={shadowCameraSize}
      // shadow-camera-top={shadowCameraSize}
      // shadow-camera-bottom={-shadowCameraSize}
      // shadow-radius={4}
    />
  );
}
